import router from '@/router'

const stageNextRouteMap = {
	// Current Status: Next Route
	ACCOUNT_CREATED: 'Login',
	MOBILE_VERIFIED: 'PersonalInfo',
	PERSONAL_INFO_GIVEN: 'done',
	VIDEO_WATCHED: 'done',
	TEST_SUBMITTED: 'done',
	ADDRESS_SUBMITTED: 'done',
	TEST_SUBMITTED: 'done',
	TEST_TIMEDOUT: 'done',
	TEST_SKIPPED: 'done',
	SAMPLE_COLLECTED: 'done',
	ADDRESS_SUBMITTED: 'done',
	ADDRESS_SKIPPED: 'done',
}

export const moveToNextRoute = (stage) => {
	let name = stageNextRouteMap[stage]
	router.currentRoute.name !== name && router.push({ name })
}
